import { mapState } from 'pinia'

import AccountMenuList from 'src/components/account_menu/account_menu_list.vue'
import Popover from 'src/components/popover/popover.vue'
import UserAvatar from 'src/components/user_avatar/user_avatar.vue'

import { useAnnouncementsStore } from 'src/stores/announcements.js'
import { useChatsStore } from 'src/stores/chats.js'
import { useFollowRequestsStore } from 'src/stores/follow_requests.js'
import { useUsersStore } from 'src/stores/users.js'

// The desktop's account menu: the avatar in the top bar, and its pop-up
export default {
  components: { AccountMenuList, Popover, UserAvatar },
  computed: {
    ...mapState(useUsersStore, ['currentUser']),
    ...mapState(useChatsStore, ['unreadChatsCount']),
    ...mapState(useFollowRequestsStore, ['followRequestsCount']),
    ...mapState(useAnnouncementsStore, ['unreadAnnouncementsCount']),
    // something in the menu waits for you
    waiting() {
      return !!(
        this.unreadChatsCount ||
        this.followRequestsCount ||
        this.unreadAnnouncementsCount
      )
    },
  },
}
